<template>
    <b-modal id="modal-help-and-contact"
             hide-footer
             centered
             v-model="isVisible"
             :title="$t('cdb.subscriptions.help_and_support')"
    >
        <div class="row">
            <div class="col-12">
                <data-entry-column :title="$root.whitelabel.state.contact.name" :full-width="true">
                    <template v-slot:value>
                        <p>{{ $root.whitelabel.state.contact.address.street }} {{ $root.whitelabel.state.contact.address.house_nr }}</p>
                        <p>{{ $root.whitelabel.state.contact.address.plz }} {{ $root.whitelabel.state.contact.address.city }}</p>
                    </template>
                </data-entry-column>
                <data-entry-column :title="$t('pds.partner_info.email')" :full-width="true">
                    <template v-slot:value>
                        <p><a :href="getMailCta">{{ $root.whitelabel.state.contact.email }}</a></p>
                    </template>
                </data-entry-column>
                <data-entry-column :title="$t('pds.partner_info.phone')" :full-width="true">
                    <template v-slot:value>
                        <p><a :href="getPhoneCta">{{ $root.whitelabel.state.contact.tel }}</a></p>
                    </template>
                </data-entry-column>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import { EventBus } from '../../event-bus';
import DataEntryColumn from "../atoms/DataEntryColumn.vue";

export default {
    name: 'ModalHelpAndContact',
    components: {
        DataEntryColumn,
        BModal,
    },
    data() {
        return {
            isVisible: false,
        }
    },
    mounted() {
        EventBus.$on('init-help-modal', this.getData);
    },
    methods: {
        getData() {
            this.isVisible = true
        }
    },
    computed: {
        getMailCta(){
            return `mailto:${this.$root.whitelabel.state.contact.email}`
        },
        getPhoneCta(){
            return `call:${this.$root.whitelabel.state.contact.tel}`
        }
    }
}
</script>
